import {TicketFilterOptions} from "@pages/tickets/models/ticket-list-type";
import {useTranslation} from "react-i18next";

export const useTicketDropdownLabels = () => {
    const { t } = useTranslation();
    const getLabel = (ticketOption: TicketFilterOptions) => {
        switch (ticketOption) {
            case TicketFilterOptions.ShowAllTicket:
                return t('tickets.show_all');
            case TicketFilterOptions.ActiveTickets:
                return t('tickets.only_open_tickets');
            case TicketFilterOptions.SolvedAndClosed:
                return t('tickets.solved_and_closed_tickets');
            case TicketFilterOptions.CustomFilter:
                return t('tickets.custom_filters');
            default:
                return 'Unknown';
        }
    }

    return {getLabel};
}